import { Grid } from "@mui/material";
import React, { useEffect } from "react";

import { useNavigate } from "react-router";
import useGetPageInfo from "../../common/hooks/useGetPageInfo";
import Dashboard from "../../components/dashboard";
import BreadcrumbsComponent from "../../components/shared/breadcrumbs";

const GraphicalViewPage = () => {
  const pageInfo = useGetPageInfo();
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/GV/GVView");
  }, []);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Dashboard menuList={pageInfo.child} cartTitle={pageInfo.title} />
      </Grid>
    </Grid>
  );
};

export default GraphicalViewPage;
